import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { AccountsApi, RequestStrategyEnum, type WithSignal, type AccountRequest, type AccountResponse } from '@shared/api';

const getAccountsEffect = createEffect(({ signal, ...request }: WithSignal<AccountRequest> = {}) => AccountsApi.getAccounts(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<AccountResponse[]>([])
  .on(getAccountsEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getAccountsEffect.pending, (_, data) => data)
  .on(getAccountsEffect.fail, () => false)
  .on(getAccountsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAccountsEffect, () => null)
  // .on(getAccountsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getAccountsEffect.fail, () => 'Something went wrong while fetching Accounts. Please try again.')
  .on(getAccountsEffect.done, () => null)
  .reset(clearEvent);

export const $initialAccountsStore = {
  events: {
    getAccounts: ApiUtils.wrapperApi(getAccountsEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
